module.exports = __webpack_public_path__ + "archivist_fuga.gif?6ea037ece426e30d3b62150861932ce2";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_fuga.gif
// module id = 369
// module chunks = 0